import Http from '../common/http';
import ApiUtil from '../utils/api.util';

const RESOURCE_NAME = 'specialities';

const SpecialityService = {
  getPagedResult() {
    return Http.get(`/${RESOURCE_NAME}`);
  },
  getList(degreeTypeId) {
    const queryString = ApiUtil.buildArrayToQueryString('degreeType', [degreeTypeId]);

    return Http.get(`/${RESOURCE_NAME}/list?${queryString}`);
  },
  create() {
    return Http.post(`/${RESOURCE_NAME}`);
  },
  del(id) {
    return Http.delete(`/${RESOURCE_NAME}/${id}`);
  },
};

export default SpecialityService;
